<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates40">
<p class="centerImage"><img alt="images" id="plate40" src="images/plate40.jpg"/></p>
<p class="caption">Still waiting! Harold Leonard, RWF, Bill Gibbs, Robin Norwood, and Clive Caldwell, the wing leader.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates40.vue?6b9d27e3